import { render, staticRenderFns } from "./SendMessageReplyDetailBox.vue?vue&type=template&id=2fd9d7ff&scoped=true&lang=pug"
import script from "./SendMessageReplyDetailBox.vue?vue&type=script&lang=ts"
export * from "./SendMessageReplyDetailBox.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageReplyDetailBox.vue?vue&type=style&index=0&id=2fd9d7ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd9d7ff",
  null
  
)

export default component.exports